import React, { useState } from 'react';
import '../../custom-styles/Layout.scss';
import LanguageDropdown from './components/LanguageDropdown';
import Sidebar from './components/Sidebar';
import UserBox from './components/UserBox';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };


  return (
    <div className="d-flex min-vh-100 flex-column">
      {/* Top Header */}
      <header className="text-white p-3 gg-header">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-sm-6 d-flex align-items-center gap-3">
              <button className="btn btn-outline-light" onClick={handleSidebar}>
                ☰
              </button>
              <h1 className="h5 mb-0">{process.env.REACT_APP_NAME}</h1>
            </div>

            <div className="col-sm-6 text-end">
               <UserBox />
               <LanguageDropdown />
            </div>
          </div>
        </div>
      </header>


      {/* Body: Sidebar + Main */}
      <div className="d-flex flex-grow-1">
        <Sidebar isSidebarOpen={sidebarOpen} />

        {/* Main content */}
        <main className="flex-fill py-4">
          {children}
        </main>
      </div>

      {/* Footer */}
      <footer className="text-center py-3 border-top gg-footer">
        &copy; {new Date().getFullYear()} {process.env.REACT_APP_NAME}
      </footer>
    </div>
  );
};

export default Layout;
